export enum UpdateEventName {
    Remove = "remove",
    Rename = "rename",
    Saved = "saved",
    Update = "update",
    EnabledToggle = "enabledToggle",
    ExpandToggle = "expandToggle",
    AddProfile = "addProfile",
}
